import { CheckPermissionsModes } from "@elit-hair/elit-tools";
import {
    TbAdjustmentsHorizontal,
    TbCalendarEvent,
    TbChartBar,
    TbFileDescription,
    TbGauge,
    TbPhoneCheck,
    TbReportAnalytics,
    TbTable,
    TbTelescope,
    TbUsersGroup,
} from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const performanceRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.PERFORMANCE,
        meta: {
            label: "performance",
            order: 3,
            icon: TbChartBar,
            visibleInSidebar: true,
        },
        children: [
            {
                to: APP_ROUTES_TO.PERFORMANCE_KPIS,
                meta: {
                    label: "kpis",
                    order: 1,
                    icon: TbReportAnalytics,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_KPIS_READ],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_SETTING_PRIORITY_REPORT,
                meta: {
                    label: "setting_capacities",
                    order: 2,
                    icon: TbAdjustmentsHorizontal,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SETTING_PRIORITY_COUNTS],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_CALENDAR_CAPACITIES,
                meta: {
                    label: "calendar_capacities_title",
                    order: 3,
                    icon: TbCalendarEvent,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_CALENDAR_CAPACITIES],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_TEAM_PERFORMANCE,
                meta: {
                    label: "team_performance",
                    order: 4,
                    icon: TbUsersGroup,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_QUALITY_WATCH,
                meta: {
                    label: "quality_watch",
                    order: 5,
                    icon: TbTelescope,
                    visibleInSidebar: false,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_AGENT_QUALITY_MATRIX,
                meta: {
                    label: "agent_quality_matrix",
                    order: 6,
                    icon: TbTable,
                    visibleInSidebar: false,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_CALL_VOLUME,
                meta: {
                    label: "call_volume",
                    order: 7,
                    icon: TbGauge,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_REACHABILITY_ANALYSIS,
                meta: {
                    label: "reachability_analysis",
                    order: 8,
                    icon: TbPhoneCheck,
                    visibleInSidebar: true,
                    permissions: [
                        PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE,
                        PERMISSIONS.CALL_SVC_ADMIN_BASE,
                        PERMISSIONS.CALL_REACHABILITY_ANALYSIS,
                    ],
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_REPORTS,
                meta: {
                    label: "reports",
                    order: 9,
                    icon: TbFileDescription,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_REPORTS_PRP_ADMIN, PERMISSIONS.CALL_REPORTS_SALES_ADMIN],
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
        ],
    },
];
